import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import FalconPagination from "components/common/custom/pagination";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect, useState } from "react";
import { Card, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Gear, Pen } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { DeleteEmpolyee, GetAllEmpolyee } from "../config/empolyeeApi";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { nationalityData } from "features/practitioner/utils";
import { useAppContext } from "providers/AppProvider";

const EmpolyeeListTable = ({
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  data,
  page,
  setting,
  rowsPerPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    config: { isDark }
  } = useAppContext();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalRow, setModalRow] = useState(null);

  const handleConfirmDelete = async () => {
    const response = await dispatch(
      DeleteEmpolyee(modalRow?.employees_id)
    ).unwrap();
    if (response?.success) {
      const body = {
        name: "",
        branch: "",
        id: "",
        email: "",
        role: "",
        start_point: 0,
        limit: 10,
      };
      toast.success(response?.message_en);
      const res = await dispatch(GetAllEmpolyee(body)).unwrap();
    } else {
      toast.error(response?.message_en);
    }
  };
  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "empolyee",
      header: "User ID",
      cell: ({ row: { original } }) => original?.employees_id || "",
    },
    {
      accessorKey: "empol",
      header: "User Name",
      cell: ({ row: { original } }) =>
        `${original?.employees_firstname || ""} ${original?.employees_familyname
        }`,
    },
    {
      accessorKey: "branch",
      header: "Branch Name",
      cell: ({ row: { original } }) => {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip
                id={`tooltip-branch-${original.employees_id}`}
                style={{
                  "--bs-tooltip-bg": "transparent",
                  "--bs-tooltip-padding-y": "0",
                  "--bs-tooltip-padding-x": "0",
                }}
              >
                <div className={isDark ? "bg-dark" : "bg-white"}
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    borderRadius: "12px",
                    background: "rgba(11, 23, 39, 0.95)",
                    backdropFilter: "blur(10px)",
                    border: isDark ? "1px solid rgba(255, 255, 255, 0.15)" : "1px solid rgba(0, 0, 0, 0.1)",
                    boxShadow: isDark ? "0 20px 40px rgba(0,0,0,0.4)" : "0 10px 30px rgba(0,0,0,0.1)",
                    width: "300px",
                    minWidth: "280px",
                    maxWidth: "600px",
                    zoom: "75%"
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2 mb-2 pb-2"
                    style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}
                  >
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: "#00d27a",
                        boxShadow: "0 0 12px rgba(0, 210, 122, 0.6)",
                      }}
                    ></div>
                    <span
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "800",
                        textTransform: "uppercase",
                        letterSpacing: "0.1rem",
                        color: isDark ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)",

                      }}
                    >
                      Branches Name
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      lineHeight: "1.5",
                      color: isDark ? "#f8fafc" : "#000",
                    }}
                  >
                    {original?.branch_name}
                  </div>
                </div>
              </Tooltip>
            }
          >
            <div
              className="text-truncate d-flex align-items-center"
              style={{
                maxWidth: "280px",
                cursor: "pointer",
                padding: "4px 12px",
                borderRadius: "20px",

                fontWeight: "600",
                fontSize: "0.8rem",
                transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <span className="text-truncate">{original?.branch_name || "N/A"}</span>
            </div>
          </OverlayTrigger >
        );
      },
    },
    {
      accessorKey: "nation",
      header: "National ID",
      cell: ({ row: { original } }) => original?.employees_nationalid || "",
    },
    {
      accessorKey: "role",
      header: "Role",
      cell: ({ row: { original } }) => original?.rolename || "",
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: ({ row: { original } }) => original?.employees_emailid || "",
    },
    {
      accessorKey: "mobile",
      header: "Mobile No",
      cell: ({ row: { original } }) => original?.employees_mobilenumber || "",
    },
    {
      accessorKey: "nationality",
      header: "Nationality",
      cell: ({ row: { original } }) =>
        original?.nationality ||
        nationalityData?.find(
          (item) => item?.value === original?.employees_nationality
        )?.title ||
        "",
    },
    {
      accessorKey: "actions",
      header: <Gear />,
      enableSorting: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {(Number(setting?.add) === 1 ||
              Number(setting?.view) === 1 ||
              Number(setting?.edit) === 1 ||
              Number(setting?.delete) === 1) && (
                <CardDropdown
                  icon="ellipsis-v"
                  dropdownClassName="py-2 custom-dropdown-menu"
                >
                  {Number(setting?.view) === 1 && (
                    <Dropdown.Item
                      onClick={() =>
                        navigate(
                          `${paths.addEmpolyeeList}/${original?.employees_id}/view`
                        )
                      }
                    >
                      <FontAwesomeIcon icon="eye" className="me-2" />
                      View
                    </Dropdown.Item>
                  )}
                  {Number(setting?.edit) === 1 && (
                    <Dropdown.Item
                      onClick={() =>
                        navigate(
                          `${paths.addEmpolyeeList}/${original?.employees_id}`
                        )
                      }
                    >
                      <Pen className="me-2" />
                      Edit
                    </Dropdown.Item>
                  )}
                  {Number(setting?.delete) === 1 && (
                    <Dropdown.Item
                      onClick={() => {
                        setShowDeleteModal(true);
                        setModalRow(original);
                      }}
                    >
                      <FontAwesomeIcon icon="trash" className="me-2" />
                      Delete
                    </Dropdown.Item>
                  )}
                </CardDropdown>
              )}
          </>
        );
      },
    },
  ];
  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);
  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this record?"
      />
    </div>
  );
};

export default EmpolyeeListTable;
